import * as twgl from 'twgl';
import { onMount, onDestroy } from "./_";
import { Raf } from "@lib/subs";
import { Resize } from "@lib/subs";

const vertexShader = `
attribute vec4 position;
varying vec2 v_texCoord;

void main() {
  gl_Position = position;
  v_texCoord = (position.xy + 1.0) * 0.5;
}
`;

const fragmentShader = `
precision mediump float;
uniform float u_time;
uniform vec2 u_mouse;
uniform vec2 u_resolution;

varying vec2 v_texCoord;

void main() {
  vec2 uv = v_texCoord;
  vec2 mouse = u_mouse / u_resolution;
  
  // Off-black base color
  vec3 color = vec3(0.05, 0.05, 0.05);
  
  // Subtle time-based animation
  float timeEffect = sin(u_time * 0.5) * 0.02;
  color += vec3(timeEffect);
  
  // Subtle mouse interaction
  vec2 dist = uv - mouse;
  float mouseEffect = 1.0 / (length(dist) * 2.0 + 1.0) * 0.03;
  color += vec3(mouseEffect);
  
  gl_FragColor = vec4(color, 1.0);
}
`;

export default function (element: HTMLElement, dataset: DOMStringMap) {
  // const canvas = element.querySelector('.loader') as HTMLCanvasElement;

  // if (!canvas) {
  //   console.warn('Loader module: No canvas element with class "loader" found');
  //   return;
  // }

  // let gl: WebGLRenderingContext | null = null;
  // let programInfo: twgl.ProgramInfo | null = null;
  // let bufferInfo: twgl.BufferInfo | null = null;
  // let mouseX = 0;
  // let mouseY = 0;
  // let rafUnsubscribe: (() => void) | null = null;
  // let resizeUnsubscribe: (() => void) | null = null;

  // function handleMouseMove(e: MouseEvent) {
  //   mouseX = e.clientX;
  //   mouseY = e.clientY;
  // }

  // onMount(() => {
  //   // Get WebGL context
  //   gl = canvas.getContext('webgl');

  //   if (!gl) {
  //     console.error('Loader module: WebGL not supported');
  //     return;
  //   }

  //   // Create shader program
  //   programInfo = twgl.createProgramInfo(gl, [vertexShader, fragmentShader]);

  //   if (!programInfo) {
  //     console.error('Loader module: Failed to create shader program');
  //     return;
  //   }

  //   // Create buffer for full-screen quad
  //   const arrays = {
  //     position: {
  //       numComponents: 2,
  //       data: [
  //         -1, -1,
  //         1, -1,
  //         -1, 1,
  //         -1, 1,
  //         1, -1,
  //         1, 1,
  //       ],
  //     },
  //   };

  //   bufferInfo = twgl.createBufferInfoFromArrays(gl, arrays);

  //   // Set canvas size
  //   function resizeCanvas() {
  //     twgl.resizeCanvasToDisplaySize(canvas);
  //     gl!.viewport(0, 0, canvas.width, canvas.height);
  //   }

  //   resizeCanvas();

  //   // Mouse tracking
  //   window.addEventListener('mousemove', handleMouseMove);

  //   // Resize handler
  //   resizeUnsubscribe = Resize.add(() => {
  //     resizeCanvas();
  //   });

  //   // Animation loop using RAF
  //   rafUnsubscribe = Raf.add(({ time, delta }) => {
  //     if (!gl || !programInfo || !bufferInfo) return;
  //     // Set uniforms
  //     const uniforms = {
  //       u_time: time * 100, // Scale time appropriately
  //       u_mouse: [mouseX, window.innerHeight - mouseY],
  //       u_resolution: [canvas.width, canvas.height],
  //     };

  //     // Render
  //     gl.useProgram(programInfo.program);
  //     twgl.setBuffersAndAttributes(gl, programInfo, bufferInfo);
  //     twgl.setUniforms(programInfo, uniforms);
  //     twgl.drawBufferInfo(gl, bufferInfo);
  //   });
  // });

  // onDestroy(() => {
  //   if (rafUnsubscribe) {
  //     rafUnsubscribe();
  //   }
  //   if (resizeUnsubscribe) {
  //     resizeUnsubscribe();
  //   }
  //   window.removeEventListener('mousemove', handleMouseMove);

  //   // Clean up WebGL resources
  //   if (gl && programInfo) {
  //     gl.deleteProgram(programInfo.program);
  //   }
  // });
}

